export default {
  'cove.datepicker.selectDate': 'Select a Date',

  'cove.dialog.expand': 'Expand',
  'cove.dialog.collapse': 'Collapse',

  'cove.confirm.prompt.prefix': 'Type',
  'cove.confirm.prompt.suffix': 'below to continue...',

  'cove.general.cancel': 'Cancel',
  'cove.general.close': 'Close',
  'cove.general.confirm': 'Confirm',
  'cove.general.ok': 'OK',

  'cove.validation.date.after': '{0} cannot be after {1}.',
  'cove.validation.date.before': '{0} cannot be before {1}.',
  'cove.validation.date.invalid': 'The {0} field is not a valid date format.',

  'cove.validation.integer.greaterThan': 'The {0} field may not be greater than {1}.',
  'cove.validation.integer.greaterThanEqualTo': 'The {0} field may not be greater than or equal to {1}.',
  'cove.validation.integer.invalid': 'The {0} field is not a valid number format.',
  'cove.validation.integer.lessThan': 'The {0} field may not be less than {1}.',
  'cove.validation.integer.lessThanEqualTo': 'The {0} field may not be less than or equal to {1}.',

  'cove.validation.number.greaterThan': 'The {0} field may not be greater than {1}.',
  'cove.validation.number.greaterThanEqualTo': 'The {0} field may not be greater than or equal to {1}.',
  'cove.validation.number.invalid': 'The {0} field is not a valid number format.',
  'cove.validation.number.lessThan': 'The {0} field may not be less than {1}.',
  'cove.validation.number.lessThanEqualTo': 'The {0} field may not be less than or equal to {1}.',

  'cove.validation.required': 'The {0} field is required.',
  'cove.validation.string.maxLength': 'The {0} field cannot exceed {1} characters.',

  'cove.validation.time.invalid': 'The {0} field is not a valid time format.'
};